module.exports = __webpack_public_path__ + "img/housingmatch.f35cdea4.png";